import { useQuery, useMutation } from "@tanstack/react-query";
import { GetTimeSlotsById, BookTimeSlot } from "../infrastructure/timeslotService";

export function useTimeSlots(token: string | undefined, enabled: boolean = true) {
    return useQuery({
        queryKey: ["timeSlots", token],
        queryFn: () => GetTimeSlotsById(token!),
        enabled: !!token && enabled,
        staleTime: 5 * 60 * 1000,
    });
}

export function useBookTimeSlot(token: string) {
    return useMutation({
        mutationFn: ({ timelineId, captchaToken }: { timelineId: string; captchaToken?: string }) =>
            BookTimeSlot(token, timelineId, captchaToken),
        onSuccess: () => {
            // This is commented out to stop reloading the page, after a successful confirmation
            // queryClient.invalidateQueries({ queryKey: ["timeSlots", token] });
        },
        onError: (error) => {
            console.error('Booking failed:', error);
        }
    });
}
